import { Redirect } from '@change-corgi/core/react/router';

import { useStartAPetitionPageFcmExperiments } from 'src/app/pages/startAPetition/pageContext';

import { AIAsksChoiceLoader } from './AIAsksChoiceLoader';

export const AIAsksChoiceWrapper = () => {
	const experiments = useStartAPetitionPageFcmExperiments();

	const isFcmEnabled = experiments.psfToSapLocalFlowExperiment.fcm.config.isEnabled;
	const isControl = experiments.psfToSapLocalFlowExperiment.variation === 'control';

	if (!isFcmEnabled || isControl) return <Redirect to="/start-a-petition" forceMode="external" />;

	return <AIAsksChoiceLoader />;
};
